import { Injectable } from '@angular/core';

import { WidgetType } from '@frontend/sports/types/components/widget';
import { WidgetNavigation } from '@frontend/sports/types/components/widget/types';

import { WidgetTabBarItem } from './widget-tab-bar.component';

export abstract class WidgetTabBarMapperService {
    abstract map(widgetId: string, navigation: WidgetNavigation[], navigationOptions: unknown): WidgetTabBarItem[];
    abstract getCount(navigation: WidgetNavigation[], navigationOptions: unknown): number | undefined;
    protected getId(widgetId: string, item: WidgetNavigation): string {
        return `${widgetId}-${item.id}`;
    }
}

@Injectable({
    providedIn: 'root',
})
export class WidgetTabBarMapperRegistryService {
    private registry = new Map<WidgetType, WidgetTabBarMapperService>();

    register(type: WidgetType, mapper: WidgetTabBarMapperService): void {
        this.registry.set(type, mapper);
    }

    get(type: WidgetType): WidgetTabBarMapperService | undefined {
        return this.registry.get(type);
    }
}
